import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useModalStore } from "../../../hooks/modal.hooks";
import { useSendUserMessage } from "../../../networking/consultant.hooks";
import AppInput from "../../Core/AppInput/AppInput";
import AppText from "../../Core/AppText/AppText";
import Button from "../../Core/Button/Button";
import Checkbox from "../../Core/Checkbox/Checkbox";
import Modal from "../../Core/Modal/Modal";
import TextArea from "../../Core/TextArea/TextArea";
import Flex from "../../Layout/Flex";

interface MessageModalProps {
	consultantId: string;
	title?: string;
}

const MessageModal: React.FC<MessageModalProps> = ({ consultantId, title }) => {
	const toggleModal = useModalStore((state) => state.toggleMessageModal);
	const { mutate: sendMessage, isLoading } = useSendUserMessage();

	const { t } = useTranslation();

	const [message, setMessage] = useState("");
	const [channels, setChannels] = useState({
		sms: true,
		push: true,
		mail: false, // Note: We don't want to send email from here
	});

	const handleSubmit = async () => {
		await sendMessage({
			body: {
				title: "",
				message,
				users: [{ id: consultantId }],
				channels,
			},
		});

		setTimeout(() => {
			toggleModal();
		}, 100);
	};

	return (
		<Modal onClose={toggleModal}>
			<Flex direction="column">
				{title && (
					<AppText size="l" weight="medium" margin="0 0 1rem 0">
						{title}
					</AppText>
				)}

				<TextArea value={message} onChangeText={setMessage} label="Message" />

				<Flex direction="column" margin="1rem 0 0 0" gap="0.5rem">
					<Checkbox
						isChecked={channels.sms}
						label="SMS"
						onChange={() =>
							setChannels({
								...channels,
								sms: !channels.sms,
							})
						}
					/>
					<Checkbox
						isChecked={channels.push}
						label="Pushnotis"
						onChange={() =>
							setChannels({
								...channels,
								push: !channels.push,
							})
						}
					/>
				</Flex>
			</Flex>

			<Flex
				direction="row"
				alignItems="center"
				justifyContent="flex-end"
				margin="1.5rem 0 0 0"
				gap="0.75rem"
			>
				<Button
					loading={isLoading}
					onClick={() => toggleModal()}
					textColor="black"
					backgroundColor="buttonGray"
				>
					{t("CANCEL")}
				</Button>
				<Button onClick={handleSubmit} width="150px">
					{t("SEND")}
				</Button>
			</Flex>
		</Modal>
	);
};

export default MessageModal;
